import { ReactNode } from 'react';
import cx from 'classnames';
import { Text } from '@intellecteu/common-ui';

import s from './styles.module.scss';

interface IAvatarMenu {
  collapsed?: boolean;
  name?: string;
  children: ReactNode;
}

export const AvatarMenu = ({ collapsed, name, children }: IAvatarMenu) => {
  return (
    <div className={cx(s.menu, collapsed && s.menuCollapsed)}>
      <Text className={s.menuText} size={Text.size.xs}>
        {name}
      </Text>
      {children}
    </div>
  );
};
